import { render, staticRenderFns } from "./device_detail_sheet_scrollBar.vue?vue&type=template&id=3d04f4ee&scoped=true"
import script from "./device_detail_sheet_scrollBar.vue?vue&type=script&lang=js"
export * from "./device_detail_sheet_scrollBar.vue?vue&type=script&lang=js"
import style0 from "./device_detail_sheet_scrollBar.vue?vue&type=style&index=0&id=3d04f4ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d04f4ee",
  null
  
)

export default component.exports